module.exports = __webpack_public_path__ + "media/challenge.a8b22fcf.mp3";